import {createEvent} from "effector";

export const setMapLoadedEv = createEvent()

export const resetMapLoadedEv = createEvent()
